import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { TableData } from '../../../components';
import { errorAlert } from '../../../helpers/alerts';
import { getEmailReportHistoryGlobalService } from '../../../services/report/emailReportService';
import { Box } from '@mui/material';
import moment from 'moment';
const ranges = {
  daily: 'Diario',
  weekly: 'Semanal',
  monthly: 'Mensual'
}

const types = {
  balance: 'Saldos',
  movements: 'Movimientos',
}
const EmailReportGlobalHistoryScreen = () => {
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    getEmailReportHistoryGlobalService()
      .then((response) => setHistory(response.data))
      .catch((e) => {
        errorAlert(e);
        navigate(-1);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  return (
    <Box mt={2}>
      <TableData
        dataRows={history}
        loading={loading}
        dataTitle={[
          "Grupo/Commercio",
          "Frecuencia",
          "Tipo",
          "Correos",
          "Fecha",
          "Estatus",
        ]}
        formatter={({ group, hoster, period, reportType, createdAt, status, emails }) => [
          group?.name || hoster?.username || "-",
          period in ranges ? ranges[period] : "-",
          reportType in types ? types[reportType] : "-",
          {
            type: "text",
            value: (emails?.length ? emails?.join(", ") : "") || "-",
            maxWidth: 150
          },
          moment(createdAt).format("DD/MM/YYYY HH:mm:ss"),
          status || "-",
        ]}
      />
    </Box>
  )
}

export default EmailReportGlobalHistoryScreen
